<template>
  <el-dialog
    title="选择图片"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    append-to-body
    width="1000px"
  >
    <div>
      <el-upload
        class="upload"
        :multiple="true"
        action=""
        accept="image/jpeg,image/png,image/gif"
        :show-file-list="false"
        :data="localpostData"
        :http-request="handleUpload"
        :before-upload="beforeAvatarUpload"
        :on-success="handleAvatarSuccess"
        :on-error="uploadError"
      >
        <el-button
          size="small"
          type="primary"
        >
          上传图片
        </el-button>
      </el-upload>
      <div
        v-loading="loading"
        class="pic-list"
      >
        <div
          v-for="(item, index) in imageList"
          :key="item.id"
          class="pic-item"
          @click="checkedImg(item, index)"
        >
          <div class="pic-img">
            <img
              :src="item.image_url"
              alt=""
              srcset=""
              class="pic"
            >
          </div>
          <div class="pic-name">
            {{ item.image_name }}
          </div>
          <!-- 遮罩 -->
          <div
            v-if="item.selected"
            class="selected_mask"
          >
            <div class="selected_mask_inner">
              <div class="selected_mask_icon el-icon-check" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ localcheckedItem.length }}张图片</span>
        <el-button
          type="primary"
          @click="saveImageAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * @author lr
 * @description 表格网：
 * @see The https://ba-uat.shopex123.com/customer/statistics @view/customer/statistics.vue
 * @since version 1.0
 * @returns {Array}
 * @param {Array} columns 列字段
 * @param {Number} pageSize 页数据量
 * @param {Boolean} nopagination 是否展示分页
 * @param {Function} onPageChange 分页事件会调
 */

import { getImageList, uploadImage } from '@/api/component'
import UploadUtil from '../../utils/uploadUtil'
export default {
  name: 'SpImageSelect',
  props: {
    imageVisible: {
      // 展示选择图片的模态框
      type: Boolean,
      default: false
    },
    chooseOne: {
      // 只可选择一个
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      total_count: 0,
      params: {
        page: 1,
        page_size: 21
      },
      imageList: [],
      localpostData: {
        token: '',
        key: '',
        fname: ''
      },
      localcheckedItem: []
    }
  },
  computed: {
    showDialog () {
      return this.imageVisible
    }
  },
  watch: {
    imageVisible (newVal, oldVal) {
      if (newVal) {
        this.localcheckedItem = []
        this.getImageList()
      }
    }
  },
  methods: {
    // 选择图片
    checkedImg (item, index) {
      if (this.chooseOne) {
        // 图片单选
        this.imageList.map((v) => (v.selected = false))
        item.selected = true
        this.localcheckedItem = this.imageList.filter((v) => v.image_id === item.image_id)
      } else {
        // 图片多选
        item.selected = !item.selected
        if (item.selected) {
          this.localcheckedItem.push(item)
        } else {
          this.localcheckedItem = this.localcheckedItem.filter((v) => v.image_id !== item.image_id)
        }
      }
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getImageList()
    },

    // 关闭模态框
    cancelAction () {
      this.$emit('closeImageDialog')
    },
    // 保存绑定
    saveImageAction () {
      this.$emit('chooseImage', this.localcheckedItem)
    },
    // 获取图片列表
    async getImageList () {
      this.loading = true
      const data = await getImageList(this.params)
      if (data) {
        data.list.forEach((v) => {
          v.selected = false
          this.localcheckedItem.forEach((item) => {
            if (item.selected && item.image_id === v.image_id) {
              v.selected = true
            }
          })
        })

        this.imageList = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    // 自定义上传
    handleUpload: function (e) {
      const upload = new UploadUtil()
      // 上传
      upload
        .uploadImg(e.file, e.file.name)
        .then(
          (res) => e.onSuccess(res),
          (err) => e.onError(err)
        )
        .catch((err) => e.onError(err))
    },
    // 上传错误回调
    uploadError: function (e) {
      this.$message.error(e)
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 10

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }

      this.localpostData.fname = file.name
    },
    handleAvatarSuccess (res, file) {
      console.log('--handleAvatarSuccess--', res, file)
      let uploadParams = {
        image_cat_id: 2, //图片分类必填,必须为整数
        image_name: file.name, //图片名称必填,不能超过50个字符
        image_url: res.key, //图片链接必填
        // image_full_url: res.height,   //图片完整链接必填
        image_type: file.raw.type, //图片分类长度不能超过20个字符
        storage: 'image' //图片id必填
      }
      // if (res.key) {
      this.$api.qiniu.uploadQiniuPic(uploadParams).then((res) => {
        this.$message({
          message: '上传成功',
          type: 'success',
          duration: 5 * 1000
        })
        this.isLoadData = false
        this.getImageList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pic-list {
  display: flex;
  flex-wrap: wrap;
  margin: 20px -10px 0;

  .pic-item {
    width: 117px;
    height: 153px;
    margin: 0 10px 20px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    position: relative;
    .pic-img {
      width: 100%;
      height: 117px;
      .pic {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .pic-name {
      line-height: 36px;
      padding: 0 6px;
      color: #606266;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .selected_mask {
      width: 100%;
      height: 117px;
      position: absolute;
      left: 0;
      top: 0;
      .selected_mask_inner {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        .selected_mask_icon {
          color: #fff;
          font-size: 32px;
        }
      }
    }
  }
}
</style>
